/**
 * Recepten module enum-ish constants.
 *
 * Like the todo module, this file carries only the sync table set — disjoint from
 * groceries' `SYNC_TABLES`, agenda's `AGENDA_SYNC_TABLES` and todos'
 * `TODO_SYNC_TABLES` — so the module keeps its own independent sync channel. The
 * display enums (source type) live in schemas.ts beside the row.
 *
 * One table: a recipe is edited as a whole, so per-row LWW is the right grain and
 * "pin to the top" is just a boolean on that row (migration 038, which also dropped
 * the short-lived week planner `recept_plan`).
 */
export const RECEPT_SYNC_TABLES = ['recepten'];
export function isReceptSyncTable(value) {
    return RECEPT_SYNC_TABLES.includes(value);
}
//# sourceMappingURL=enums.js.map